export default function SectionHeader({ title, note }) {
  return (
    <div className="analytics-section-head">
      <h2 className="analytics-section-title">{title}</h2>
      {note ? <p className="analytics-section-note">{note}</p> : null}
    </div>
  );
}
